import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const CurlyBraces = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8.00039 20C6.34354 20 5.00039 18.6569 5.00039 17V14.5612C5.00039 13.9537 4.72421 13.3791 4.24978 12.9995L3.48843 12.3904C3.23823 12.1903 3.23823 11.8097 3.48843 11.6096L4.24978 11.0005C4.72421 10.6209 5.00039 10.0463 5.00039 9.43875V7C5.00039 5.34315 6.34354 4 8.00039 4M16.0004 20C17.6572 20 19.0004 18.6569 19.0004 17V14.5612C19.0004 13.9537 19.2766 13.3791 19.751 12.9995L20.5123 12.3904C20.7626 12.1903 20.7626 11.8097 20.5123 11.6096L19.751 11.0005C19.2766 10.6209 19.0004 10.0463 19.0004 9.43875V7C19.0004 5.34315 17.6572 4 16.0004 4",
            stroke: "currentColor",
            strokeWidth: 2 * (24 / size),
            strokeLinecap: "round"
        })
    });
};
